import { boolean, number, object, string } from 'yup';
import { useMemo } from 'react';
import { toRepliconDate } from '~/modules/common/dates/convert';
import { getResourceRequestDatesFromProjectDate } from '~/modules/resourcing/common/util';
import { getMaxDateForAllocation } from '~/modules/resourcing/components/AllocateResourcePopup/hooks/useAllocateResourcePopupHandler';
import { ALLOCATION_PERIOD } from '../../AllocationByPeriod';

const validationSchema = object().shape({
  startDate: object()
    .shape({
      year: number().required(),
      month: number().required(),
      day: number().required()
    })
    .required(),
  endDate: object()
    .shape({
      year: number().required(),
      month: number().required(),
      day: number().required()
    })
    .required(),
  isClearAllocationChecked: boolean(),
  selectedAllocationPeriod: string()
    .oneOf(Object.values(ALLOCATION_PERIOD))
    .required()
});

export const useSetResourceAllocationFormState = ({ project, scale } = {}) => {
  const {
    requestEndDate: endDate,
    requestStartDate: startDate
  } = getResourceRequestDatesFromProjectDate({
    projectStartDate: project.startDate,
    projectEndDate: project.endDate,
    scale
  });

  const initialValues = useMemo(
    () => ({
      startDate: toRepliconDate(startDate),
      endDate: toRepliconDate(getMaxDateForAllocation({ startDate, endDate })),
      isClearAllocationChecked: false,
      selectedAllocationPeriod: ALLOCATION_PERIOD.ENTIRE_PERIOD,
      hoursForEntirePeriod: '',
      percentageForEntirePeriod: '',
      hoursPerMonth: '',
      hoursPerWeek: ''
    }),
    [startDate, endDate]
  );

  return {
    initialValues,
    validationSchema
  };
};
